import { theme } from '@features/executive-report/domain/theme';
import { DEFAULT_FONT } from '@features/executive-report/utils';
import { ChartProps } from '@features/powerpoint';

export const chartColors = ['#2E75B6', '#548235'] as const;

export const defaultChartOptions: ChartProps['options'] = {
  catAxisLabelColor: theme.colors.white,
  catAxisMajorTickMark: 'none',
  catAxisLabelFontFace: DEFAULT_FONT,

  valAxisHidden: true,

  showValue: true,
  dataLabelColor: theme.colors.white,
  dataLabelPosition: 'ctr',
  dataLabelFontFace: DEFAULT_FONT,
};
